import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {FolderHierarchy} from '../models/folder.model';
import {BindPoliciesDto, BindPolicyResponse, UnbindRetentionsCommand} from '../models/retention.model';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FolderService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  hierarchy(folderId: string): Observable<FolderHierarchy> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'folder/' + folderId + '/hierarchy');
    return this.http.get<FolderHierarchy>(url);
  }

  bind(libraryId: string, folderId: string, dto: BindPoliciesDto): Observable<BindPolicyResponse> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'library/' + libraryId + '/folder/' + folderId + '/binding');
    return this.http.post<BindPolicyResponse>(url, dto);
  }

  unbind(libraryId: string, folderId: string, policyIds: UnbindRetentionsCommand): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'library/' + libraryId + '/policy/' + policyIds.retentionsIds[0] + '/binding' + '?folderId=' + folderId);
    return this.http.delete<void>(url);
  }
}
